<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">
    <a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle">
      <!-- Sign In Form Column -->
      <a-col
        :span="24"
        :md="12"
        :lg="{ span: 12, offset: 0 }"
        :xl="{ span: 6, offset: 2 }"
        class="col-form"
      >
        <h1 class="mb-15">Sign In</h1>
        <h5 class="font-regular text-muted">
          Enter your email and password to sign in
        </h5>

        <!-- Sign In Form -->
        <a-form
          id="components-form-demo-normal-login"
          :form="form"
          class="login-form"
          @submit="handleSubmit"
          :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="登录账号" :colon="false">
            <a-input
              v-decorator="[
                'username',
                {
                  rules: [
                    { required: true, message: 'Please input your usernmae!' },
                  ],
                },
              ]"
              placeholder="登录账号"
            />
          </a-form-item>
          <a-form-item class="mb-5" label="登录密码" :colon="false">
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    { required: true, message: 'Please input your password!' },
                  ],
                },
              ]"
              type="password"
              placeholder="Password"
            />
          </a-form-item>
          <a-form-item class="mb-10" label="验证码" :colon="false">
            <div class="captcha-field">
              <a-input
                v-decorator="[
                  'captchaCode',
                  {
                    rules: [
                      { required: true, message: '请输入验证码!' },
                    ],
                  },
                ]"
                placeholder="请输入验证码"
              />
              <button
                type="button"
                class="captcha-image"
                title="点击切换验证码"
                :disabled="captchaLoading"
                @click="getCaptcha"
              >
                <a-spin v-if="captchaLoading" size="small" />
                <img v-else-if="captchaImage" :src="captchaImage" alt="验证码" />
                <span v-else>点击获取</span>
              </button>
            </div>
          </a-form-item>
          <!-- <a-form-item class="mb-10">
            <a-switch v-model="rememberMe" /> Remember Me
          </a-form-item> -->
          <a-form-item>
            <a-button
              type="primary"
              block
              html-type="submit"
              class="login-form-button"
              :loading="loading"
            >
              点击登录
            </a-button>
          </a-form-item>
        </a-form>
        <!-- / Sign In Form -->

        <del
          ><p class="font-semibold text-muted">
            Don't have an account?
            <router-link to="/sign-in" class="font-bold text-dark"
              >Sign Up</router-link
            >
          </p></del
        >
      </a-col>
      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col :span="24" :md="12" :lg="12" :xl="12" class="col-img">
        <img src="images/login.png" alt="" />
      </a-col>
      <!-- Sign In Image Column -->
    </a-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      // Binded model property for "Sign In Form" switch button for "Remember Me" .
      rememberMe: true,
      loading: false,
      captchaImage: "",
      captchaKey: "",
      captchaLoading: false,
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    ...mapActions(["LoginOk"]),
    getCaptcha() {
      if (this.captchaLoading) {
        return;
      }

      this.captchaLoading = true;
      this.$http({
        url: "/admin/sys/captcha",
        method: "get",
      })
        .then((res) => {
          const captchaData = res.data || {};
          this.captchaImage = captchaData.captchaImage || "";
          this.captchaKey = captchaData.captchaKey || "";
          this.form.setFieldsValue({ captchaCode: "" });
        })
        .catch(() => {
          this.captchaImage = "";
          this.captchaKey = "";
        })
        .finally(() => {
          this.captchaLoading = false;
        });
    },
    // Handles input validation after submission.
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          return;
        }

        if (!this.captchaKey) {
          this.$message.warning("请先获取验证码");
          this.getCaptcha();
          return;
        }

        this.loading = true;
        this.$http({
          url: "/admin/sys/login",
          method: "post",
          data: {
            ...values,
            captchaKey: this.captchaKey,
          },
        })
          .then((res) => {
            this.$message.success("登录成功");
            this.LoginOk(res.data.token);
            this.$router.replace("/dashboard");
          })
          .catch(() => {
            this.getCaptcha();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss">
body {
  background-color: #ffffff;
}

.captcha-field {
  display: flex;
  align-items: center;
  gap: 10px;

  .ant-input {
    flex: 1;
  }
}

.captcha-image {
  width: 120px;
  height: 40px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 4px;

  &:disabled {
    cursor: not-allowed;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
